export enum FilterMatchModeValue {
	IS = 'IS',
	IS_NOT = 'IS_NOT',
	CONTAINS = 'CONTAINS'
}